import { ContextKey } from '@pubstack/common/src/contextKey'
import { FunctionComponent, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useContextKeys } from '~/api/adm-api.hook'
import { useToast } from '~/components/Toast/useToasts'
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs'
import { sortContextKeyValues } from './contextKeyValues'
import { PureAdmContextKeysPage } from './PureAdmContextKeysPage'

export const AdmContextKeysPage: FunctionComponent = () => {
  const navigate = useNavigate()
  const breadcrumbs = useBreadcrumbs()
  const [contextKeys, setContextKeys] = useState<ContextKey[]>([])
  const toast = useToast()
  const { all } = useContextKeys(null)

  const loadContextKeyPageData = async () => {
    if (all.loading) {
      all.abort()
    }

    try {
      const result = await all.get()
      setContextKeys(result.map((contextKey) => ({ ...contextKey, values: sortContextKeyValues(contextKey) })))
    } catch (_e) {
      toast.alert(`It seems that no configuration has been created for this scope. Context keys can't be retrieved. Please contact support team.`, { icon: 'rocket', duration: Infinity })
    }
  }

  useEffect(() => {
    // Legitimate data load on mount (async fetch then setState).
    // oxlint-disable-next-line react/set-state-in-effect
    loadContextKeyPageData()
  }, [])

  return (
    <PureAdmContextKeysPage
      contextKeys={contextKeys}
      isLoading={all.loading}
      onCreateContextKey={() => navigate(`/monetization/one/context/context-keys/new`)}
      onUpdateContextKey={(contextKey) => navigate(`/monetization/one/context/context-keys/edit/${contextKey.name}`)}
      breadcrumbs={breadcrumbs}
    />
  )
}
